import App from './app';

// ESLint Global var declaration
/* global appOptions */

// webpack include of the site SASS/CSS
//require('../css/main.scss');

const app = new App(appOptions);
app.start();



// WEBPACK FOOTER //
// ./js/boot.js